import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Box from "@material-ui/core/Box";
import { SecondaryButton } from "@prestosports/commons-ui";
import TeamLogo from "../../team/components/TeamLogo";
import participantConfirmationStyles from "../../team/styles/ParticipantConfirmation.styles";
import CsvDownloadButton from "../../common/components/CsvDownloadButton";
import VirtualizedList from "../../common/components/VirtualizedList";

const PlayerRow = (player) => {
	const { firstName, lastName, uniform, positions } = player || {};

	return (
		<ListItem divider button dense>
			<ListItemText
				primary={`${firstName} ${lastName}`}
				secondary={`${uniform}${positions.length ? " | " : ""}${positions
					.map(({ name }) => name)
					.join(" / ")}`}
			/>
		</ListItem>
	);
};

const ParticipantConfirmationList = ({
	onModifyParticipants,
	participants,
	team,
	getCsvContent
}) => {
	const classes = participantConfirmationStyles();

	return (
		<Box className={classes.participationList}>
			<TeamLogo size="small" team={team} teamNamePosition="right" />
			<VirtualizedList
				items={participants}
				className={classes.participationListContainer}
				rowRenderer={PlayerRow}
			/>
			<Box className={classes.participationListControls}>
				<SecondaryButton
					label="Modify"
					onClick={() => {
						onModifyParticipants(team.id);
					}}
				/>
				<CsvDownloadButton
					label="Export"
					csvContent={getCsvContent(team.id)}
					filename={`${team.teamName}-participating-players.csv`}
				/>
			</Box>
		</Box>
	);
};

export default ParticipantConfirmationList;
